import React, { Component } from "react";
import { fetchBasemapEsri_search } from "../../api/portal";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { pushLoader } from "actions/main";
import { pushBasemap, pushDateVersion } from "actions/portal";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Grid from '@material-ui/core/Grid';
import GridList from '@material-ui/core/GridList';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { withStyles } from '@material-ui/core/styles';
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Datetime from "react-datetime";
import moment from "moment";

import NavPills from "components/NavPills/NavPills.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import ChartistGraph from "react-chartist";
import Search from "../Leftpanel/search";
import Tracking from "../Leftpanel/tracking";
import Zonatracking from "../Leftpanel/zonatracking";
import ChangeDest from "../Leftpanel/changedest";
import IncompleteInfo from "../Leftpanel/incompleteinfo";
import Inactive from "../Leftpanel/inactive";
import IdleClose from "../Leftpanel/idleclose";

import LeftpanelPOI from "./leftpanelPOI";

import { multipleBarsChart } from "variables/charts.jsx";
import { withRouter } from "react-router-dom";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

const styles = theme => ({
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2),
  },
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    height: 224,
  },
  tabs: {
    borderRight: `2px solid ${theme.palette.divider}`,
  },
});

class contentLeftpanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alert: null,
      show: false,
      basmapesrilist: null,
      basemap: "female",
      date_version: moment().format("DD-MM-YYYY"),
      value: 0
    };
  }

  UNSAFE_componentWillMount() {
    this.props.pushDateVersion(moment().format("YYYYMMDD"));
    // fetchBasemapEsri_search(this.state.date_version)
    //   .then(response => {
    //     this.props.pushLoader(false);
    //     this.setState({ basmapesrilist: response.data.results });
    //   })
    //   .catch(error => {
    //     console.log(error);
    //   });
  }

  handleChange = event => {
    this.setState({ basemap: event.target.value });
    this.props.pushBasemap(event.target.value);
  };

  handleDate = event => {
    //console.log(moment(event._d));

    let datenya = moment(event._d, "YYYY MMMM DD").format("YYYY-MM-DD");
    this.props.pushDateVersion(moment(event._d, "YYYY MMMM DD").format("YYYYMMDD"));
    //console.log(moment(event._d, 'YYYY MMMM DD').format("YYYY-MM-DD"));
    this.setState({ date_version: datenya });
    fetchBasemapEsri_search(datenya)
      .then(response => {
        this.props.pushLoader(false);
        this.setState({ basmapesrilist: response.data.results });
      })
      .catch(error => {
        console.log(error);
        // this.props.history.push("/pages/login#logout");
      });
  };

  handleTab = (event, newValue) => {
    this.setState({value: newValue});
  };

  render() {
    
    const { classes } = this.props;
    // if(this.state.basmapesrilist == null){
    //   return false;
    // }

    return (
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <div className={classes.content}>
          <GridList cellHeight={400} style={{width: "100%" ,height: 600,}}>
          <div className={classes.root}>
            <Tabs
              orientation="vertical"
              variant="scrollable"
              indicatorColor="secondary"
              textColor="primary"
              value={this.state.value}
              onChange={this.handleTab}
              aria-label="Vertical tabs example"
              className={classes.tabs}
            >
              <Tab label="Search" {...a11yProps(0)} />
              <Tab label="Vessel Tracking & Monitoring" {...a11yProps(1)} />
              <Tab label="Zona Tracking & Monitoring" {...a11yProps(2)} />
              <Tab label="Inactive" {...a11yProps(3)} />
              <Tab label="Contiguous Vessel" {...a11yProps(4)} />
              <Tab label="Changed Destination" {...a11yProps(5)} />
              <Tab label="Incomplete AIS Info" {...a11yProps(6)} />
            </Tabs>
            <TabPanel value={this.state.value} index={0}>
              <Search />
            </TabPanel>
            <TabPanel value={this.state.value} index={1}>
              <Tracking />
            </TabPanel>
            <TabPanel value={this.state.value} index={2}>
              <Zonatracking />
            </TabPanel>
            <TabPanel value={this.state.value} index={3}>
              <Inactive />
            </TabPanel>
            <TabPanel value={this.state.value} index={4}>
              <IdleClose />
            </TabPanel>
            <TabPanel value={this.state.value} index={5}>
              <ChangeDest />
            </TabPanel>
            <TabPanel value={this.state.value} index={6}>
              <IncompleteInfo/>
            </TabPanel>
          </div>
            {/* < NavPills
              color="rose"
              horizontal={{
                tabsGrid: { xs: 3, sm: 12, md: 3 },
                contentGrid: { xs: 9, sm: 12, md: 9 }
              }}
              tabs={[
                {
                  tabButton: "Search",
                  tabContent: (
                    <div>
                      <Search />
                      <br/><br/>
                    </div>
                  )
                },
                {
                  tabButton: "Vessel Tracking & Monitoring",
                  tabContent: (
                    <Tracking />
                  )
                },
                {
                  tabButton: "Zona Tracking & Monitoring",
                  tabContent: (
                    <Zonatracking />
                  )
                },
                {
                  tabButton: "Inactive",
                  tabContent: (
                    <Inactive />
                  )
                },
                {
                  tabButton: "Contiguous Vessel",
                  tabContent: (
                    <IdleClose />
                  )
                },
                {
                  tabButton: "Changed Destination",
                  tabContent: (
                    <ChangeDest />
                  )
                },
                {
                  tabButton: "Incomplete AIS Info",
                  tabContent: (
                    <IncompleteInfo/>
                  )
                }
              ]}
            /> */}
          </GridList>
          </div>              
        </Grid>
      </Grid>
    );
  }
}

function mapStateToProps(state) {
  return {
    blocking: state.loader
  };
}

contentLeftpanel.propTypes = {
  classes: PropTypes.object.isRequired,
  pushLoader: PropTypes.bool,
  pushBasemap: PropTypes.string,
  pushDateVersion: PropTypes.string
};

export default withRouter(connect(
  mapStateToProps,
  { pushLoader, pushBasemap, pushDateVersion }
)(withStyles(styles)(contentLeftpanel)));
